export const AuthShell = ({ title, kicker, children }) => (
  <div className="min-h-screen grid grid-cols-12">
    <aside className="hidden lg:flex col-span-5 bg-[var(--rf-ink)] text-white p-12 flex-col justify-between">
      <div className="flex items-center gap-3">
        <span className="w-4 h-4 bg-[var(--rf-red)]" />
        <span className="font-extrabold tracking-tight text-lg">Reverse Frame</span>
      </div>
      <div className="space-y-8">
        <p className="rf-mono text-xs tracking-[0.3em] uppercase text-white/50">01 — 06</p>
        <h2 className="text-5xl xl:text-6xl font-extrabold leading-[0.95] tracking-tight">
          Ogni immagine<br />è un prompt<br /><span className="rf-red">nascosto.</span>
        </h2>
        <p className="text-white/60 max-w-sm text-sm leading-relaxed">
          Carica una foto o una clip. Il direttore della fotografia IA la scompone in soggetto, scena, stile, luce e camera, e ti restituisce il prompt per rigenerarla.
        </p>
      </div>
      <p className="rf-mono text-[10px] tracking-[0.3em] uppercase text-white/40">Midjourney · Sora · Runway · Stable Diffusion</p>
    </aside>
    <main className="col-span-12 lg:col-span-7 flex items-center px-6 sm:px-16 py-16">
      <div className="w-full max-w-md rf-fade">
        <p className="rf-mono text-xs tracking-[0.3em] uppercase rf-red mb-4">{kicker}</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-12">{title}</h1>
        {children}
      </div>
    </main>
  </div>
);
